'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

/**
 * Last-resort boundary for errors that escape the root layout.
 *
 * Deliberately not localized: next-intl's provider lives inside the layout this
 * boundary replaces, so `useTranslations` would throw here and swallow the real
 * error behind a second one. Next's stock error page is the safe fallback.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* App Router does not surface a status code here, so pass 0 to render
            the generic message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
